import React, {useState} from 'react';
import { Box, Collapse, TableCell, Grid, Typography, TableRow, Button, Modal } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { resetRemarks } from '../../../../store/dcs';
import RemarksModal from '../../modals/Remarks';
import styles from './styles'
import { NoShow } from '../NoShow';
import { InlineEdit } from "../InlineEdits";
import _ from 'lodash'

// NOTE // formats output data for editing a phone number (to use in dcs store's editPax)
const savePhone = (pax, paxPhone) => {
  // NOTE // removing special characters
  paxPhone = paxPhone.split(' ').join('')
  paxPhone = paxPhone.split('(').join('')
  paxPhone = paxPhone.split(')').join('')
  paxPhone = paxPhone.split('+').join('')
  paxPhone = paxPhone.split('.').join('')

  let output = {
    editData: {paxNumber: pax?.PaxNumber, phoneNumber: paxPhone, ctcNumber: pax?.ctcNumber},
    rloc: pax?.PNRRefNo,
    type: 'editPhone'
  }
  return output
}

// NOTE // formats output data for editing weight (to use in dcs store's editPax)
const saveWeight = (pax, paxWeight) => {
  paxWeight = paxWeight + 'LBS'

  let output = {
    editData: {paxNumber: pax?.PaxNumber, weight: paxWeight},
    rloc: pax?.PNRRefNo,
    type: 'editWeight'
  }
  return output
}

const PaxInfoSecondary = (props) => {
  const dispatch = useDispatch();
  const { pax, openAccordion, classes, modalClasses } = props;
  const [openRemarks, setOpenRemarks] = useState(false);
  const [ETStatus, setETStatus] = useState(pax.ETStatus)
  const editPaxStatus = useSelector(state => state.entities.dcs.editPaxStatus)

  const handleOpenRemarks = () => {
    setOpenRemarks(true);
  };

  const handleCloseRemarks = () => {
    dispatch(resetRemarks());
    setOpenRemarks(false);
  };

  return (
    <TableRow className={classes.border}>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderTop: '1px solid #b9b9b9' }} colSpan={12}>
        <Collapse in={openAccordion} timeout="auto" unmountOnExit>
          <Box margin={0}>
            <Grid container>
              <Grid item xs={6} className={classes.alignLeft}>
                <Typography><span className={classes.bold}>Seg Status:</span> {pax.PAXType + ' ' + pax.SegStatus}</Typography>
              </Grid>
              <Grid item xs={6} className={classes.alignRight}>
                <Typography><span className={classes.bold}>Fare Class:</span> {pax.FareType}</Typography>
              </Grid>
              <Grid item xs={6} className={classes.alignLeft} style={{marginTop: '5px'}}>
                <InlineEdit pax={pax} classes={classes} initialValue={pax?.phone} label={"Phone"} id={"phone-edit"} onSave={savePhone} editStatus={editPaxStatus.find(item => item.type === 'editPhone')} />
              </Grid>
              <Grid item xs={6} className={classes.alignRight} style={{marginTop: '5px'}}>
                <InlineEdit pax={pax} classes={classes} initialValue={pax?.Weight?.split('L')[0]} label={"Weight"} id={"weight-edit"} onSave={saveWeight} editStatus={editPaxStatus.find(item => item.type === 'editWeight')} />
              </Grid>
              <Grid item xs={6} className={classes.remarksButton}>
                <div>
                  <Button variant="contained" size="small" onClick={handleOpenRemarks} style={{textTransform: 'none', fontSize: 'smaller'}}>Remarks</Button>
                  <Modal 
                    open={openRemarks} 
                    onClose={handleCloseRemarks} 
                    aria-labelledby="simple-modal-title" 
                    aria-describedby="simple-modal-description"
                  >
                    <RemarksModal pax={pax} modalClasses={modalClasses} />
                  </Modal>
                </div>
              </Grid>
              <Grid item xs={6} className={classes.alignRight}>
                <NoShow pax={pax} /*flight={flight}*/ status={ETStatus} setStatus={setETStatus} />
              </Grid>
            </Grid>
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}

export default withStyles(styles)(PaxInfoSecondary)